export function getQlikAppId(state) {
  const { page } = state.navigationSelection;

  if (page.hasOwnProperty('sheet')) {
    return page.sheet[0].qlikAppId;
  }

  return '';
}
